// Port of api/fuel/app/classes/filter/search/games/filters/query/game/age/threshold.php
export default {
	name: 'game.age.threshold',
	priority: 50,
	require: function(config, filter) { return filter.threshold && filter.threshold.age > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_age_count', '>=', filter.threshold.age)
	}
}
